<template>
  <div v-if="isShow">
    <div class="body" style="background-color: rgb(26 32 116 / .6);">
      <form @submit.prevent="putLogin">
        <div id="login">
          <div class="logo">
            <img :src="source_domain + '/images/logo.png'">
          </div>
          <div class="input">
            <el-input type="text" v-model="login.username" @keyup.enter.native="putLogin" prefix-icon="el-icon-user"
                      placeholder="请输入账号"></el-input>
          </div>
          <div class="input">
            <el-input type="password" v-model="login.password" @keyup.enter.native="putLogin" prefix-icon="el-icon-lock"
                      placeholder="请输入密码"></el-input>
          </div>
          <div class="input">
            <el-input type="text" maxlength="4" v-model="login.code" @keyup.enter.native="putLogin" prefix-icon="el-icon-cpu"
                      placeholder="请输入验证码"></el-input>
            <img class="code" :src="codeImg" @click="getCodeImg()" v-if="codeImg">
          </div>
          <div id="btn">
            <span class="btn_dl" @click="putLogin">登录</span>
            <span class="btn_cz" @click="resetInput">重置</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {setToken} from '@/utils/auth'

  export default {
    components: {},
    data() {
      return {
        source_domain: this.config.SOURCE_DOMAIN,
        codeImg: '',
        login: {
          key: '',
          username: '',
          password: '',
          code: ''
        },
        isShow: false
      };
    },
    created() {
      var _this = this
      this.getUserInfo()
      setTimeout(function () {
        _this.isShow = true
      }, 300)
    },
    mounted() {
      this.getCodeImg()
    },
    computed: {},
    methods: {
      getCodeImg() {
        var that = this
        this.$api.merchant.codeImg(function (res) {
          if (res.errcode == 0) {
            that.codeImg = res.data.img
            that.login.key = res.data.key
          } else {
            that.fail(res.errmsg)
          }
        })
      },
      getUserInfo() {
        var that = this
        this.$api.merchant.myIndex(function (res) {
          console.log(res)
          if (res.errcode == 0) {
            that.$router.push({name: 'person_index'})
          } else {
            that.fail(res.errmsg)
          }
        })
      },
      resetInput() {
        var that = this
        that.login.key = ''
        that.login.username = ''
        that.login.password = ''
        that.login.code = ''
      },
      putLogin() {
        var that = this
        if (that.login.username == '') {
          that.tips('用户名不能为空！')
          return ''
        }
        if (that.login.password == '') {
          that.tips('密码不能为空！')
          return ''
        }
        if (that.login.code == '') {
          that.tips('验证码不能为空！')
          return ''
        }
        that.showLoading()
        var param = that.login
        this.$api.merchant.authLogin(param, function (res) {
          that.hideLoading()
          if (res.errcode == 0) {
            setToken(res.data.access_token)
            that.success('登录成功')
            that.$router.push({name: 'person_index'})
          } else {
            that.getCodeImg()
            that.fail(res.errmsg)
          }
        })
      }
    }
  };
</script>
<style scoped>
  .body {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  #login {
    width: 760px;
    height: 503px;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(44, 103, 144, 0.5);
    box-shadow: 10px 17px 20px 0px rgba(44, 103, 144, 0.35);
    border-radius: 20px;
    margin: auto;
  }

  .input {
    margin-left: 180px;
    margin-top: 20px;
    width: 400px;
    position: relative;
  }

  .input .code {
    position: absolute;
    right: 0;
    top: 0;
  }

  .logo {
    text-align: center;
    margin-top: 50px;
  }
  .logo img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-bottom: 30px;
    background-color: #fff;
    padding: 15px;
    box-shadow:
        0 0 5px rgba(26, 32, 116, 0.9),
        0 0 20px rgba(26, 32, 116, 0.6),
        0 0 50px rgba(26, 32, 116, 0.3);
  }

  #btn {
    padding-top: 25px;
  }

  .btn_dl {
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 50px;
    line-height: 50px;
    background: #1A2074;
    box-shadow: 1px 2px 2px 0 rgba(44, 103, 144, 0.15);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 30px;
    margin-left: 230px;
    margin-right: 50px;
    cursor: pointer;
  }

  .btn_cz {
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 50px;
    line-height: 50px;
    background: #FFFFFF;
    border: 1px solid #D5D7DC;
    box-shadow: 1px 2px 2px 0 rgba(44, 103, 144, 0.15);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
  }

</style>
